<template>
  <div>
    <main class="main">
        <div class="bredcumb">
          <div class="container">
            <ul>
              <li> <router-link to="/index">首頁</router-link></li>
              <li>紅包使用說明</li>
            </ul>
          </div>
        </div>

        <!--優惠券使用說明開始-->
        <div class="bodyContent">
          <div class="container">
            <section class="p_mgin20">
              <div class="innerHeader">
                <h1>紅包使用說明</h1>
              </div>
              <div class="tabs"><!-- tab is here -->
                <ul class="tabsNav cf">
                  <li>
                    <a href="/coupon_Android">Android</a>
                  </li>
                  <li>
                    <a href="#tab2">iOS</a>
                  </li>
                  <li>
                    <a href="/coupon_web">官網</a>
                  </li>
                </ul>

                <div class="contents">
                  <div id="tab1"></div><!-- tab1 end -->

                  <div id="tab2">
                    <p>歡迎您使用一刻鯨選，拿到紅包折扣碼卻不知道怎麼使用嗎？快跟著以下步驟來試試看吧！</p>
                    <!-- <ul class="directNavs cf">
                        <li><a href="#step1">如何存入優惠券</a></li>
                        <li><a href="#step3">如何使用優惠券</a></li>
                    </ul> -->

                    <h2 id="step1">Step 1 登入官方網站</h2>
                    <p>
                      至「一刻鯨選」官網，點選右上角的「登入」登入會員之後，在選單點選「紅包」選項。
                    </p>
                    <div class="descriptionImg">
                      <figure><img src="@/assets/images/coupon_direction/ios/ios-step1-1.jpg" alt="App Store"></figure>
                      <figure><img src="@/assets/images/coupon_direction/ios/ios-step1-2.jpg" alt="App Store"></figure>
                    </div>

                    <h2>Step 2 輸入折扣碼</h2>
                    <p>
                        在「紅包」頁面輸入折扣碼後，按下「確定」，折扣輕鬆到手！
                    </p>
                    <div class="descriptionImg">
                      <figure><img src="@/assets/images/coupon_direction/ios/ios-step2-1.jpg" alt="App Store"></figure>
                      <figure><img src="@/assets/images/coupon_direction/ios/ios-step2-2.jpg" alt="App Store"></figure>
                    </div>

                    <h2 id="step3">Step 3 下載App</h2>
                    <p>
                      再到 App Store 下載〈一刻鯨選〉 App，手機快速開啟 App Store，請點<a href="https://itunes.apple.com/tw/app/id1440248584?l=zh&mt=8" target="_blank">這裡</a>
                    </p>
                    <div class="descriptionImg">
                      <figure><img src="@/assets/images/coupon_direction/ios/ios-step3-1.jpg" alt="App Store"></figure>
                    </div>

                    <h2 id="step4">Step 4 使用折扣碼 </h2>
                    <p>
                      打開App登入帳號後，找到您要購買的主題包，點擊「上架驚喜價」或「優惠售價」→「使用紅包優惠」後方的「請選擇＞」，就可以看到已經歸戶的折價券，開心點下去^^！
                    </p>
                    <div class="descriptionImg">
                      <figure><img src="@/assets/images/coupon_direction/ios/ios-step4-1.jpg" alt="App Store"></figure>
                      <figure><img src="@/assets/images/coupon_direction/ios/ios-step4-2.jpg" alt="App Store"></figure>
                      <figure><img src="@/assets/images/coupon_direction/ios/ios-step4-3.jpg" alt="App Store"></figure>
                    </div>

                    <h2 id="step5">Step 5 兌換主題包</h2>
                    <p>
                      畫面自動跳轉回到購買頁面，看見「使用紅包優惠」前方的打勾圖示變成藍色，代表折扣使用成功，可以馬上用優惠價格兌換喜愛的課程囉！
                    </p>
                    <div class="descriptionImg">
                      <figure><img src="@/assets/images/coupon_direction/ios/ios-step5-1.jpg" alt="輸入紅包"></figure>
                    </div>

                    <p>
                        ※ 備註<br>
                        1. <a href="/coupon_Android">這裡</a>有 Android 裝置詳細的使用說明
                    </p>
                  </div><!-- tab2 end -->

                </div><!-- content end -->
              </div><!-- tabs end -->
            </section>
          </div>
        </div>
        <!--優惠券使用說明-->

    </main>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: 'async',
  metaInfo () {
    return {

      title: 'iOS 紅包使用說明 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: 'iOS 紅包使用說明 | 一刻鯨選' },
        { property: 'og:site_name', content: 'iOS 紅包使用說明 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！' }

      ]
    }
  },

  mounted () {
    $(document).ready(function () {
      // Tabs functionality
      // Firstly hide all content divs
      $('.contents > div').hide()
      // Then show the first content div
      $('.contents > div:nth-child(2)').show()
      // Add active class to the first tab link
      $('.tabsNav li:nth-child(2)').addClass('active')
      // Functionality when a tab is clicked
      $('.tabsNav li a').click(function () {
        // Firstly remove the current active class
        $('.tabsNav li').removeClass('active')
        // Apply active class to the parent(li) of the link tag
        $(this).parent().addClass('active')
        // Set currentTab to this link
        var currentTab = $(this).attr('href')
        // Hide away all tabs
        $('.contents > div').hide()
        // show the current tab
        $(currentTab).show()
        // Stop default link action from happening
        return false
      })
    })

    $("a[href^='#']").click(function (e) {
      e.preventDefault()

      var position = $($(this).attr('href')).offset().top - 125

      $('body, html').animate({
        scrollTop: position
      } /* speed */)
    })
  }
}
</script>

<style>
@import '../../assets/css/user.css';
@import '../../assets/css/user_rwd.css';
</style>



// WEBPACK FOOTER //
// src/components/views/coupon_iOS.vue